(function (angular) {
    'use strict';

    angular.module('Toyota.Angulartics')
        .factory('GtmDetails', ['$filter', function ($filter) {

            function getLabel(controlType, element) {
                switch (controlType) {
                    case 'input':
                        return element.value;
                    case 'tag input':
                        return element.innerText;
                    case 'select':
                        if (!element.value) { return ''; }
                        return element.options[element.selectedIndex].text;
                    case 'ui-select':
                        return angular.element(element).find('.ui-select-match').text().trim();
                    case 'checkbox':
                        return element.checked ? 'selected' : 'not selected';
                    default:
                        return element.getAttribute('data-gtm-label');
                }
            }

            function setEmptyPropertiesToNull(extraProps) {
                angular.forEach(extraProps, function (value, key) {
                    if (!value) {
                        extraProps[key] = null;
                    }
                });

                return extraProps;
            }

            return function (element) {
                var category = element.getAttribute('data-gtm-category');
                var action = element.getAttribute('data-gtm-action');
                var label = element.getAttribute('data-gtm-label'); // use data-gtm-label as event label if provided
                var controlType = element.getAttribute('data-gtm-control-type');
                var controlValue = getLabel(controlType ? controlType : category, element);
                var formSubmissionProp = element.getAttribute('data-gtm-form-submission-property');

                if (controlValue === '') {// if the control value is empty then set event label as not completed
                    label = 'Not completed';
                } else { // user has provided some value so provide the event label as per configuration
                    if (!label && label !== '0') { // if there is no data-gtm-label defined then make control value as label
                        label = controlValue;
                    }

                    var isPii = element.hasAttribute('data-gtm-pii');
                    if (isPii) { // Encrypt the label if configured
                        label = $filter('SHA256')(label);
                  }
                    var isHiddenPii = element.hasAttribute('data-gtm-hide-pii');
                    if (isHiddenPii) { 
                        label = action + ' added'; 
                    }
                }

                var extraProps = element.getAttribute('data-gtm-extra-props');

                if (extraProps) {
                    extraProps = setEmptyPropertiesToNull(JSON.parse(extraProps));
                }

                var extraFormSubmissionProp = element.getAttribute('data-gtm-extra-form-submission-props');

                if (extraFormSubmissionProp) {
                    extraFormSubmissionProp = setEmptyPropertiesToNull(JSON.parse(extraFormSubmissionProp));
                }

                return {
                    category: category,
                    action: action,
                    label: label,
                    formSubmitProp: formSubmissionProp,
                    extraFormSubmitProp: extraFormSubmissionProp,
                    controlType: controlType ? controlType : category,
                    extraProps: extraProps
                };
            };
        }]);
})(window.angular);
